module.exports = __webpack_public_path__ + "static/media/mobile-icons-buttons-page-navigation-right-arrow-disabled.80837209.svg";